import {PartyInfo, QcHeader} from "@/types";
import {getOperator, headers, isParty} from "@/utils";
import {settings} from "@/settings";
import {api} from "@/auth/api";
import i18n from "@/i18n";

export const getPartyInfoWithCustomer = (partyInfos: PartyInfo[]) => {
    return partyInfos.filter((partyInfo: PartyInfo) => {
        if ( isParty(partyInfo.partyData) ) {
            return partyInfo.partyData.roles?.some(item => {
                if(item.role?.type) {
                    return item.role.type.value === 'CUSTOMER'
                } else {
                    return item.role?.resourceUid === 'CUSTOMER'
                }
            })
        }
    });
}


export const getTeamMembersByManagerCode = async (filter: any) => {
    const qc_header: any = {
        qc: {
            queryId: 'user-by-network-node',
            "offset": 0,
            "limit": 100
        }
    }

    qc_header.qc.parameters = {
        ...filter
    }
    const operators = []
    if (filter.networkNodeCode) {
        operators.push(getOperator("party_party_role_network", "network_node_id", "EQUAL", `'${filter.networkNodeCode}'`, "network_node_id"))
    }
    if (operators.length > 0) {
        qc_header.qc.otherFilters = {
            expressions: [
                {
                    and: {
                        operators
                    }
                }
            ]
        }
    }

    const {data} = await api().get(settings.api_query_url, {
        headers: headers({qc: JSON.stringify(qc_header.qc)})
    });

    return data.map((el: { username: string, first_name: string; last_name: string; _daaq: string;role_code:string }) => ({
        value: `${el.first_name} ${el.last_name} ## ${el.username}`,
        label: `${i18n.global.t("demand.party.roles." + el.role_code.trim())} : ${el.first_name.trim()} ${el.last_name.trim()}`
    }));
    
    
}
